import React from 'react';
import WidgetDocuSignRelatorio from './WidgetDocuSignRelatorio';
import WidgetRelatorioHomologacao from './WidgetRelatorioHomologacao';
import WidgetObservacaoRelatorio from '../AbaFluxoProcesso/WidgetObservacaoRelatorio';

interface Props {
  parteDoFluxo?: boolean,
  ehComprador: boolean
}

const AbaRelHomologacao = ({ parteDoFluxo = false, ehComprador }: Props) => {

  return (
    <>
      <WidgetRelatorioHomologacao parteDoFluxo={parteDoFluxo} ehComprador={ehComprador} />
    </>
  );
};

export default AbaRelHomologacao;
